import script from "./PacakgeDataCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PacakgeDataCard.vue?vue&type=script&lang=ts&setup=true"

import "./PacakgeDataCard.vue?vue&type=style&index=0&id=b4c2b786&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4c2b786"]])

export default __exports__